import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberRenderer',
})
@Injectable({
  providedIn: 'root',
})
export class NumberRendererPipe implements PipeTransform {
  private readonly locale: string = 'en-US';
  private readonly options: Intl.NumberFormatOptions = {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    useGrouping: true,
  };

  transform(value: number): string {
    return value.toLocaleString(this.locale, this.options);
  }
}
